/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Sign_Out_NowInputs */

const en_users_sign_out_now = /** @type {(inputs: Users_Sign_Out_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out now`)
};

const pt_br2_users_sign_out_now = /** @type {(inputs: Users_Sign_Out_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconectar agora`)
};

/**
* | output |
* | --- |
* | "Sign out now" |
*
* @param {Users_Sign_Out_NowInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_sign_out_now = /** @type {((inputs?: Users_Sign_Out_NowInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Sign_Out_NowInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_sign_out_now(inputs)
	return pt_br2_users_sign_out_now(inputs)
});